import {usePublishEvent} from 'esp-js-react';
import * as React from 'react';

import {NavigateRequestedEvent, NAVIGATION_STORE_ID, NavigationEvents} from '../../logic';

export interface RouterLinkProps extends React.PropsWithChildren {
    to: string;
    className?: string;
    'aria-label'?: string;
}

export const RouterLink: React.FunctionComponent<RouterLinkProps> = ({to, className, 'aria-label': ariaLabel, children}: RouterLinkProps) => {
    const publishEvent = usePublishEvent();
    const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
            return;
        }
        e.preventDefault();
        publishEvent(NAVIGATION_STORE_ID, NavigationEvents.navigateRequested, {path: to} satisfies NavigateRequestedEvent);
    };
    return (
        <a href={to} className={className} aria-label={ariaLabel} onClick={onClick}>
            {children}
        </a>
    );
};
